/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Ready_AInputs */

const en_wc_faq_ready_a = /** @type {(inputs: Wc_Faq_Ready_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That depends on your documents and workflow. Our comparison covers WordCraft's advantages and limitations, including file compatibility and collaboration. Try copies of your important documents first, especially if you rely on complex formatting, macros or Microsoft 365 services.`)
};

/**
* | output |
* | --- |
* | "That depends on your documents and workflow. Our comparison covers WordCraft's advantages and limitations, including file compatibility and collaboration. Tr..." |
*
* @param {Wc_Faq_Ready_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_ready_a = /** @type {((inputs?: Wc_Faq_Ready_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Ready_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_ready_a(inputs)
});
export { wc_faq_ready_a as "wc.faq.ready.a" }